export function install() {}

export function setLocationHref(href: string) {}
